module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/notification/notification.component.css
// module id = ./src/app/admin/notification/notification.component.css
// module chunks = main